module.exports = "//public.zight.com/packs/media/images/view-grid-active-9101fd97819bff963eeb6b8edf23e646.svg";